var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3010_14109)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0A66C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06268 18.8506V9.76217H5.04186V18.8506H8.06268ZM6.55225 8.5213C7.60567 8.5213 8.26134 7.82341 8.26134 6.95125C8.24171 6.05946 7.60568 5.38094 6.57224 5.38094C5.5389 5.38094 4.86328 6.05946 4.86328 6.95125C4.86328 7.82341 5.51881 8.5213 6.53256 8.5213H6.55225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73438 18.8506H12.7552V13.7752C12.7552 13.5036 12.7748 13.2322 12.8546 13.0381C13.0729 12.4954 13.57 11.9333 14.4045 11.9333C15.4976 11.9333 15.9349 12.7667 15.9349 13.9885V18.8506H18.9554V13.6394C18.9554 10.8479 17.4651 9.5489 15.4776 9.5489C13.848 9.5489 13.1326 10.4598 12.7351 11.0802H12.7552V9.76217H9.73446C9.7741 10.615 9.73438 18.8506 9.73438 18.8506Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3010_14109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6d152294af6d64d8d4ce69fcde8de1cc.svg";
export { ForwardRef as ReactComponent };